package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/how-to-train-your-dragon". Pulls the REAL cached analysis (baked in StaticReviews). */
@Page("/isitsafe/how-to-train-your-dragon")
@Composable
fun HowToTrainYourDragonReviewPage() {
    PublicReviewPage(
        slug = "how-to-train-your-dragon",
        blurb = "Is How to Train Your Dragon OK for Muslim kids? Fitrah Filter checks movies, shows, games, and books against Islamic values. Here's the full breakdown for parents.",
    )
}
